@if (contactInfo != null) {
<div>
    <label class="header-label"><mat-icon style="vertical-align: middle; margin-right: 8px;">contact_mail</mat-icon>{{ 'ai.contactInfo' | transloco }}:</label>
    @if (fintechService.editMode!="contact") {
    <table>
        <tr>
            <td>Company:</td>
            <td>{{contactInfo?.company}}</td>
                    <td>VAT:</td>
                    <td>{{contactInfo?.vat}}</td>
                </tr>
                <tr>
                    <td>First name:</td>
                    <td>{{contactInfo?.firstName}}</td>
                    <td>Last name:</td>
                    <td>{{contactInfo?.lastName}}</td>
                </tr>
                <tr>
                    <td>Pnone1:</td>
                    <td>{{contactInfo?.phone1}}</td>
                    <td>Phone2:</td>
                    <td>{{contactInfo?.phone2}}</td>
                </tr>
                <tr>
                    <td>Email:</td>
                    <td colspan="3">{{contactInfo?.email}}</td>
                </tr>
            </table>
            <button (click)="onEditContact()" class="subButton" mat-raised-button [disabled]="fintechService.editMode!='info'"><mat-icon>edit</mat-icon>{{ 'ai.updateContact' | transloco }}</button>
    }
    @if (fintechService.editMode == 'contact') {
    <div style="padding-top: 10px;">
         <form [formGroup]="contactForm" novalidate>
             <div class="d-flex inline-flex">
                 <mat-form-field>
                     <mat-label>company</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="company" type="text" autocomplete="off">
                 </mat-form-field>
                 <mat-form-field>
                     <mat-label>vat</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="vat" type="text" autocomplete="off">
                 </mat-form-field>
             </div>
             <div class="d-flex inline-flex">
                 <mat-form-field>
                     <mat-label>First name</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="firstName" type="text" autocomplete="off">
                 </mat-form-field>
                 <mat-form-field>
                     <mat-label>Last name</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="lastName" type="text" autocomplete="off">
                 </mat-form-field>
             </div>
             <div class="d-flex inline-flex">
                 <mat-form-field>
                     <mat-label>phone1</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="phone1" type="text" autocomplete="off">
                 </mat-form-field>
                 <mat-form-field>
                     <mat-label>phone2</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="phone2" type="text" autocomplete="off">
                 </mat-form-field>
             </div>
             <div class="d-flex inline-flex">
                 <mat-form-field>
                     <mat-label>email</mat-label>
                     <input inputrestriction="basic0" matInput placeholder="" formControlName="email" type="text" autocomplete="off">
                 </mat-form-field>
             </div>
        </form>
        <div>
            <button (click)="onContactSubmit()" class="subButton" mat-raised-button [disabled]="fintechService.busy"><mat-icon>check</mat-icon>{{ 'ai.submit' | transloco }}</button>
            <button (click)="onContactCancel()" class="subButton" mat-raised-button [disabled]="fintechService.busy"><mat-icon>close</mat-icon>{{ 'ai.cancel' | transloco }}</button>
        </div>
    </div>
    }

</div>
}
